import { fabric } from "fabric";
import { CanvasPaperConfig } from "../designer/PageDesigner/PageDesigner";

export function getCanvasLowestElementBottom(canvas: fabric.Canvas): number {
  let lowestElementBottom = 0;
  canvas.forEachObject((elem) => {
    if (
      elem.top &&
      elem.height &&
      elem.top + elem.height > lowestElementBottom
    ) {
      lowestElementBottom = elem.top + elem.height;
    }
  });
  return lowestElementBottom;
}

export function getNumberOfPages(
  canvas: fabric.Canvas,
  dimensions: CanvasPaperConfig,
): number {
  const lowestElementBottom = getCanvasLowestElementBottom(canvas);
  const pages = Math.ceil(lowestElementBottom / dimensions.height);
  return pages === 0 ? 1 : pages;
}
